import {
  fetchScreensRequest,
  fetchScreensSuccess,
  fetchScreensFailure,
  fetchScreenReportRequest,
  fetchScreenReportSuccess,
  fetchScreenReportFailure,
} from "./actions";
import { fetchScreenData, fetchScreenReportsData } from "../../service/web_service";

export const fetchScreenDataThunk = (organization) => async (dispatch) => {
  dispatch(fetchScreensRequest());

  try {
    const response = await fetchScreenData(organization);
    dispatch(fetchScreensSuccess(response.response.data)); 
  } catch (error) {
    dispatch(fetchScreensFailure(error.message)); 
  }
};

export const fetchScreenReportThunk = (screenid) => async (dispatch) => {
  dispatch(fetchScreenReportRequest());

  try {
    const response = await fetchScreenReportsData(screenid);
    dispatch(fetchScreenReportSuccess(response)); 
    console.log("fetchScreenReportThunk",response)
  } catch (error) {
    dispatch(fetchScreenReportFailure(error.message)); 
  }
};